module.exports = __webpack_public_path__ + "img/section_buy_plot.99740734.png";